import React, { useState } from 'react';
import { StyledToggleButton, StyledToggleButtonGroup } from './styled';
import { GridFilterItem } from '@mui/x-data-grid';
import { CheckStatusFilterBoolean } from '../CustomColumnMenu/types';

interface YesNoToggleProps {
    value?: string;
    onChange?: (value: GridFilterItem) => void;
}

export default function YesNoToggle({ value = '', onChange }: YesNoToggleProps) {
    const [selectedValue, setSelectedValue] = useState(value);

    const handleChange = (event: React.MouseEvent<HTMLElement>, newValue: string | null) => {
        if (
            newValue === null &&
            (selectedValue === CheckStatusFilterBoolean.isChecked || selectedValue === CheckStatusFilterBoolean.isNotChecked)
        ) {
            setSelectedValue('');
            onChange?.({ value: '' } as GridFilterItem);
        } else if (newValue !== null) {
            setSelectedValue(newValue);
            onChange?.({ value: newValue } as GridFilterItem);
        } else {
            setSelectedValue('');
            onChange?.({ value: '' } as GridFilterItem);
        }
    };

    return (
        <StyledToggleButtonGroup value={selectedValue} exclusive onChange={handleChange} aria-label="yes or no selection">
            <StyledToggleButton value={CheckStatusFilterBoolean.isNotChecked}>No</StyledToggleButton>
            <StyledToggleButton value={CheckStatusFilterBoolean.isChecked}>Yes</StyledToggleButton>
        </StyledToggleButtonGroup>
    );
}
